import { AppRoutes } from '../../../Core/App/AppRoutes';
import { AppRouteType } from '../../Components/Templates/AppRouter/AppRouteType';
import { PrivateRoute } from '../../Components/Templates/AppRouter/PrivateRoute';
import { LoadableListAffairePage } from '../../Pages/Affaires/ListAffaire/LoadableListAffairePage';
import { LoadableAffaireDetailsPage } from '../../Pages/Affaires/AffaireDetails/LoadableAffaireDetailsPage';
import { LoadableAffaireCreatePage } from '../../Pages/Affaires/AffaireCreate/LoadableAffaireCreatePage';

const getListAffaireRoute = (props: object): AppRouteType => ({
    id: AppRoutes.AFFAIRE_LIST,
    render: PrivateRoute,
    props: {
        exact: true,
        path: AppRoutes.AFFAIRE_LIST,
        component: LoadableListAffairePage,
        ...props,
    },
});

const getCreateAffaireRoute = (props: object): AppRouteType => ({
    id: AppRoutes.AFFAIRE_CREATE,
    render: PrivateRoute,
    props: {
        exact: true,
        path: AppRoutes.AFFAIRE_CREATE,
        component: LoadableAffaireCreatePage,
        ...props,
    },
});

const getAffaireDetailsRoute = (porps: object): AppRouteType => ({
    id: AppRoutes.AFFAIRE_DETAILS,
    render: PrivateRoute,
    props: {
        exact: true,
        path: AppRoutes.AFFAIRE_DETAILS,
        component: LoadableAffaireDetailsPage,
        ...porps,
    },
});

export const getAffaireRoutes = (args: object) => [
    getListAffaireRoute(args),
    getCreateAffaireRoute(args),
    getAffaireDetailsRoute(args),
];
